{
  "version": 1,
  "asset_id": "794f1283-97c4-4f6c-89bc-925c2faf6a38",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/794f1283-97c4-4f6c-89bc-925c2faf6a38/vehicle-rental-truck.png",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/794f1283-97c4-4f6c-89bc-925c2faf6a38/vehicle-rental-truck.png",
  "original_filename": "vehicle-rental-truck.png",
  "size": 330280,
  "content_type": "image/png",
  "created_at": "2026-07-02T21:40:48Z"
}
